import { Link } from "react-router-dom";
import { Page } from "../../../../components/page/page";
import { useLocalization } from "../../../../hooks/use-localization/useLocalization";
import { useUser } from "../../../../hooks/use-user/useUser";
import { Form } from "../../../../components/form/form";

export const Name: React.FC = () => {
  const { user, setUser } = useUser();
  const { localize } = useLocalization();

  if (!user) {
    return null;
  }

  return (
    <Page title={localize("admin:name")}>
      <Form
        action="/me"
        method="PATCH"
        actionLabel={localize("save")}
        onSuccess={setUser}
        successMessage={localize("saved")}
      >
        <label>
          {localize("firstName")}
          <input type="text" name="firstName" defaultValue={user.firstName} />
        </label>
        <label>
          {localize("lastName")}
          <input type="text" name="lastName" defaultValue={user.lastName} />
        </label>
      </Form>
      <Link className="button secondary" to="../" relative="path">
        {localize("back")}
      </Link>
    </Page>
  );
};
